module.exports = __webpack_public_path__ + "img/r7.70b50362.png";